import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '../environments/environments';
import { Router } from '@angular/router';
import { SessionStorageService } from './session-storage.service';
import { references } from './references';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  user$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  token$: BehaviorSubject<any> = new BehaviorSubject<any>('');

  constructor(
    private http: HttpClient,
    private _router: Router,
    private _storage: SessionStorageService,
  ) {}

  onRequestLogin(body: {
    username: string;
    password: string;
  }): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    const httpOptions = {
      headers: headers,
    };

    const payload = new HttpParams()
      .set('username', body.username)
      .set('password', body.password)
      .set('client_id', references._CLIENT_ID)
      .set('grant_type', references._GRANT_TYPE)
      .set('scope', references._SCOPE);

    return this.http.post<any>(
      `${environment.TOKEN_URL}/token`,
      payload.toString(),
      httpOptions,
    );
  }
  lostPassword(mail: string): Observable<any> {
    return this.http.get<any>(
      `${environment.RESERVE_URL}/lost-password/${mail}`,
    );
  }

  logOut(): Observable<any> {
    this._storage.remove(references._STORAGE_TOKEN);
    this._storage.remove(references._STORAGE_USER);
    this._storage.remove(references._STORAGE_BRANCH);
    this._storage.remove(references._STORAGE_DATE);
    this._storage.remove(references._STORAGE_OLD_DATE);
    return of(this._router.navigate(['/login']));
  }
}
